/**
 * Etiquetas y utilidades — usuarios de organizaciones (Centro de Licencias BNT).
 * Distinto de usuarios internos BNT (/usuarios-distribuidor) y auxiliares de despacho.
 */

export const ORG_USER_ROLE_OPTIONS = [
  { value: "admin_cliente", label: "Administrador cliente" },
  { value: "operador", label: "Operador" },
  { value: "consulta", label: "Consulta" },
];

/** Alta desde Centro BNT: solo titulares/compradores (auxiliares viven en Actividades de Equipo). */
export const ORG_BUYER_OWNER_ROLE_OPTIONS = [
  { value: "admin_cliente", label: "Administrador cliente (titular)" },
];

export function formatUserSeats(user) {
  const auth = user?.authorized_users;
  const active = user?.active_users;
  if (auth == null && active == null) return "—";
  if (auth == null) return `${active ?? 0} activos`;
  return `${active ?? 0} / ${auth}`;
}

export function orgUserRoleLabel(bntOrgRole, mongoRole) {
  const role = String(bntOrgRole || mongoRole || "").toLowerCase();
  const found = ORG_USER_ROLE_OPTIONS.find((o) => o.value === role);
  if (found) return found.label;
  if (role === "admin") return "Administrador cliente";
  if (role === "user") return "Operador";
  return role || "—";
}

export function orgUserStatusLabel(status) {
  return status === "suspended" ? "Suspendido" : "Activo";
}

export function formatLastLogin(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("es-MX", { dateStyle: "short", timeStyle: "short" });
  } catch {
    return iso;
  }
}
